import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {ReserveModel} from '@app/models/reserve';
import {FormGroup} from '@angular/forms';
import {FormlyFieldConfig} from '@ngx-formly/core';
import {formly, formlyRow} from '@shared/helper/formly-helpers';
import {ReserveRepository} from '@app/@core/repositories/reserve.repository';
import {AppService} from '@shared/services/app.service';
import Reserve = ReserveModel.Reserve;

function disableWhenRefundIsFalse(): FormlyFieldConfig {
  return {
    expressionProperties: {
      'templateOptions.disabled': '!model.refund',
    },
  };
}

interface RefundFormData {
  refund: boolean;
  creditAmount?: number;
  numberOfCoupon?: number;
}

@Component({
  selector: 'app-cost-refund-dialog',
  templateUrl: './cost-refund-dialog.component.html',
})
export class CostRefundDialogComponent implements OnChanges {
  @Input() reserve: Reserve;

  // Emit true if the data is modified, false if the dialog is closed without action
  @Output() actionConfirmed = new EventEmitter<boolean>();

  formGroup = new FormGroup({});
  fields: FormlyFieldConfig[] = [
    formlyRow(formly.radio('refund', 'การคืนเงิน', [
      {label: 'คืนเงิน', value: true},
      {label: 'สนามไม่คืนเงิน', value: false},
    ])),
    formlyRow(formly.number('creditAmount', 'จำนวนเงินคืน (Credit)', {}, disableWhenRefundIsFalse())),
    formlyRow(formly.number('numberOfCoupon', 'จำนวนคูปองคืน', {}, disableWhenRefundIsFalse()))
  ];

  formData: RefundFormData = {
    refund: false,
    creditAmount: 0,
    numberOfCoupon: 0
  };

  constructor(
    private reserveRepository: ReserveRepository,
    private app: AppService
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.formData = {
      refund: false,
      creditAmount: (this.reserve?.costs.transferAmount || 0) + (this.reserve?.costs.useCreditAmount || 0),
      numberOfCoupon: this.reserve?.costs.coupons || 0
    };
  }

  onCancel(): void {
    this.actionConfirmed.emit(false);
  }

  onConfirm(): void {
    const {refund, numberOfCoupon, creditAmount} = this.formData;
    if (refund) {
      this.app.verify(numberOfCoupon || creditAmount, 'กรุณากรอกจำนวนเงินคืนและจำนวนคูปองคืน');
      this.reserveRepository.markReserveAsRefundCompleted(this.reserve.id, numberOfCoupon, creditAmount).subscribe(() => {
        this.app.toastSuccess('การคืนเงินสำเร็จ');
        this.actionConfirmed.emit(true);
      });
    } else {
      this.reserveRepository.markReserveAsRefundRefused(this.reserve.id).subscribe(() => {
        this.app.toastSuccess('การคืนเงินถูกปฏิเสธ');
        this.actionConfirmed.emit(true);
      });
    }
  }
}
